import page from './page';

export const UIHelpers = (customSortedKeyMap) => {
    return {
        sortedKeyMap: customSortedKeyMap,
        defaultSorted: [{ dataField: 'created_at', order: 'desc' }],
        initialFilter: {
            filters: null,
            sortOrder: 'desc',
            sortField: 'created_at',
            pageNumber: page.pageNumber,
            pageSize: localStorage.getItem('sizePerPage') || page.pageSize
        }
    };
};
